// SAT V4 Zone Routes Component
import { BasePortal, MainLoading } from '@ice-web-app/shared-ui';
import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { routes, toRelativePath } from './routes';

// Lazy load pages
const Dashboard = lazy(() => import('../pages/Dashboard'));
const Upload = lazy(() => import('../pages/Upload'));
const SchoolStructure = lazy(() => import('../pages/SchoolStructure'));
const UserManagement = lazy(() => import('../pages/UserManagement'));
const TeacherDetail = lazy(() => import('../pages/UserManagement/subpages/TeacherDetail'));
const PupilDetail = lazy(() => import('../pages/UserManagement/subpages/PupilDetail'));
const RulesPreferences = lazy(() => import('../pages/RulesPreferences'));
const CreateTimetable = lazy(() => import('../pages/TimetableManagement/CreateTimetable'));
const SubjectOptions = lazy(() => import('../pages/TimetableManagement/SubjectOptions'));
const ConflictResolution = lazy(() => import('../pages/TimetableManagement/ConflictResolution'));
const UserViews = lazy(() => import('../pages/TimetableManagement/UserViews'));
const ExportPage = lazy(() => import('../pages/TimetableManagement/UserViews/ExportPage'));
const VersionHistory = lazy(() => import('../pages/TimetableManagement/VersionHistory'));
const Analytics = lazy(() => import('../pages/TimetableManagement/Analytics'));
const Settings = lazy(() => import('../pages/Settings'));
const NotFound = lazy(() => import('../../portal/pages/not-found'));

export function ZoneRoutes() {
  return (
    <Routes>
      {/* Redirect base to dashboard */}
      <Route path={toRelativePath(routes.base)} element={<Navigate to={routes.dashboard} />} />

      {/* Main layout wrapper */}
      <Route
        element={
          <BasePortal
            sidebar
            microSystem
            showUserRole
            miniSidebar={true}
            navbar={true}
            sidebarHeader={true}
          />
        }
      >
        {/* 404 */}
        <Route
          path="*"
          element={
            <Suspense fallback={<MainLoading />}>
              <NotFound />
            </Suspense>
          }
        />

        {/* Dashboard */}
        <Route
          path={toRelativePath(routes.dashboard)}
          element={
            <Suspense fallback={<MainLoading />}>
              <Dashboard />
            </Suspense>
          }
        />

        {/* Upload */}
        <Route
          path={toRelativePath(routes.upload)}
          element={
            <Suspense fallback={<MainLoading />}>
              <Upload />
            </Suspense>
          }
        />

        {/* School Structure */}
        <Route
          path={toRelativePath(routes.schoolStructure)}
          element={
            <Suspense fallback={<MainLoading />}>
              <SchoolStructure />
            </Suspense>
          }
        />

        {/* User Management */}
        <Route
          path={toRelativePath(routes.userManagement.base)}
          element={
            <Suspense fallback={<MainLoading />}>
              <UserManagement />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.userManagement.teacherDetail)}
          element={
            <Suspense fallback={<MainLoading />}>
              <TeacherDetail />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.userManagement.pupilDetail)}
          element={
            <Suspense fallback={<MainLoading />}>
              <PupilDetail />
            </Suspense>
          }
        />

        {/* Rules and Preferences */}
        <Route
          path={toRelativePath(routes.rulesPreferences)}
          element={
            <Suspense fallback={<MainLoading />}>
              <RulesPreferences />
            </Suspense>
          }
        />

        {/* Timetable Management - Create Timetable */}
        <Route
          path={toRelativePath(routes.timetable.createTimetable)}
          element={
            <Suspense fallback={<MainLoading />}>
              <CreateTimetable />
            </Suspense>
          }
        />

        {/* Timetable Management - Subject Options */}
        <Route
          path={toRelativePath(routes.timetable.subjectOptions)}
          element={
            <Suspense fallback={<MainLoading />}>
              <SubjectOptions />
            </Suspense>
          }
        />

        {/* Timetable Management - Conflict Resolution */}
        <Route
          path={toRelativePath(routes.timetable.conflictResolution)}
          element={
            <Suspense fallback={<MainLoading />}>
              <ConflictResolution />
            </Suspense>
          }
        />

        {/* Timetable Management - User Views */}
        <Route
          path={toRelativePath(routes.timetable.userViews)}
          element={
            <Suspense fallback={<MainLoading />}>
              <UserViews />
            </Suspense>
          }
        />

        {/* Timetable Management - Export */}
        <Route
          path={toRelativePath(routes.timetable.export)}
          element={
            <Suspense fallback={<MainLoading />}>
              <ExportPage />
            </Suspense>
          }
        />

        {/* Timetable Management - Version History */}
        <Route
          path={toRelativePath(routes.timetable.versionHistory)}
          element={
            <Suspense fallback={<MainLoading />}>
              <VersionHistory />
            </Suspense>
          }
        />

        {/* Timetable Management - Analytics */}
        <Route
          path={toRelativePath(routes.timetable.analytics)}
          element={
            <Suspense fallback={<MainLoading />}>
              <Analytics />
            </Suspense>
          }
        />

        {/* Settings */}
        <Route
          path={toRelativePath(routes.settings)}
          element={
            <Suspense fallback={<MainLoading />}>
              <Settings />
            </Suspense>
          }
        />
      </Route>
    </Routes>
  );
}

export default ZoneRoutes;
